import React from 'react';
import Splash from './Splash.jsx';
import Aside from './Aside.jsx';
import Header from './Header.jsx';
import Works from './Works.jsx';
import TattooDes from './TattooDes.jsx';
import About from './About.jsx';
import Footer from './Footer.jsx';
import { HashRouter as Router, Switch, Route, Link, hashHistory} from "react-router-dom";
import {TransitionGroup, CSSTransition} from 'react-transition-group';

const shadowOn={
	background: 'radial-gradient(circle at 50%, rgba(0,0,0,.8)0%, rgba(0,0,0,1)8%,rgba(0,0,0,1)100%)',
};
const shadowLow={
	background: 'radial-gradient(circle at 50%, rgba(0,0,0,.1)0%, rgba(0,0,0,.8)8%,rgba(0,0,0,1)100%)',
};
const shadowZoom={
	background: 'radial-gradient(circle at 50%, rgba(0,0,0,.1)0%, rgba(0,0,0,.8)20%,rgba(0,0,0,1)100%)',
};
const shadowOff={
	background: 'none'
};

export default class App extends React.Component{
	constructor(props){
		super(props);
		this.state={
			toDelete:false,
			shadowLow:false,
			shadowOn:true,
			shadowOff:false,
			shadowZoom: false
		};
		this.hideSplash=this.hideSplash.bind(this);
		this.mouseMove=this.mouseMove.bind(this);
		this.touchStart=this.touchStart.bind(this);
		this.toShadowLow=this.toShadowLow.bind(this);
		this.toShadowOff=this.toShadowOff.bind(this);
		this.selectShadow=this.selectShadow.bind(this);
	}
	hideSplash(){
		this.setState({toDelete:true});
	}
	toShadowLow(){
		this.setState({shadowLow:true});
	}
	toShadowOff(){
		this.setState({shadowOff:!this.state.shadowOff});
	}
	selectShadow(){
		if(this.state.shadowOff){
			return shadowOff;
		}else if(this.state.shadowZoom){
			return shadowZoom;
		}else if(this.state.shadowLow){
			return shadowLow;
		}else if(this.state.shadowOn){
			return shadowOn;
		}
	}
	mouseMove(e){
		const dark = document.getElementById('dark');
		const x = e.clientX||e.touches[0].clientX;
		if(x===undefined)return;
		const y = e.clientY||e.touches[0].clientY;
		dark.style.left=x-dark.clientWidth/2+'px';
		dark.style.top=y-dark.clientHeight/2+'px';
	}
	touchStart(){
		this.setState({shadowZoom:!this.state.shadowZoom});
	}
	render(){
		return(
			<div onTouchStart={this.touchStart}
				 onTouchEnd={this.touchStart}
				 onTouchMove={this.mouseMove}
				 onMouseMove={this.mouseMove}
				 id='wrapper'>
				<div style={this.selectShadow()} id='dark'></div>
				<Router history={hashHistory}>
					<Route render={
						({location}) =>(
							<React.Fragment >
								<Aside/>
								<TransitionGroup className={'trans-group'}>
									<CSSTransition key={location.pathname} classNames='fade' timeout={{enter:700,exit:700}}>
										<Switch location={location}>
											<Route exact path="/" render={() =><Header
												shadowIsOff={this.state.shadowOff}
												toChangeShadowToOff={this.toShadowOff}/>}
											/>
											<Route exact path="/works" component={Works}/>
											<Route exact path="/about" component={About}/>
											<Route exact path="/contacts" component={Footer}/>
											<Route path="/works/:id" component={TattooDes}/>
										</Switch>
									</CSSTransition>
								</TransitionGroup>
								{
									this.state.toDelete?null:<Splash toChangeShadowToLow={this.toShadowLow} toDelete={this.hideSplash}/>
								}
							</React.Fragment>
						)
					}/>
				</Router>
			</div>
		)
	}
}